import React from 'react';
import './supplierOrders.scss';

import { useAuth } from  '../../contexts/auth'; 
import { createStore } from 'devextreme-aspnet-data';
import CustomStore from "devextreme/data/custom_store";

import DataGrid, {
    Column,
    Export,
    Popup,
    Form,
    Button,
    Pager,
    Paging,
    FilterRow,
    //HeaderFilter,
    RowDragging,
    Lookup,
    Item,
    Toolbar,
    Editing,
    Selection,
    Summary,
    Format,
    //GroupItem,
    TotalItem,
    SearchPanel
  } from 'devextreme-react/data-grid';

//import { Item} from 'devextreme-react/form';
import { useState, useEffect, useCallback  } from "react";
import { formatNumber } from 'devextreme/localization';
import notify from "devextreme/ui/notify";

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineFornitoreDettaglios'

export default function SupplierOrderDetail(props) {

  const filterPayload = { 
    idSuper: props.data.key,
    noNotes: true
  };

  //const isAddable = (props.data.data.statoId === 5 && props.data.data.versione === 1) || props.data.data.statoId === 6 ? true : false;
  // resa possibile l'aggiunta di righe anche in ordini che sono versioni originali
  const isAddable = (props.data.data.statoId === 5) || props.data.data.statoId === 6 ? true : false;
  const isEditable = props.data.data.statoId === 5 || props.data.data.statoId === 6? true : false;
  const isUpdateble = props.data.data.statoId !== 3 ? true : false;
  console.log("Modificabile: " + isEditable);

  const [tipiArticolo, setTipiArticolo] = useState({});
  const [um, setUm] = useState({});
  const [articoli, setArticoli] = useState({});
  const [imposte, setImposte] = useState({});
  const [categorie, setCategorie] = useState({});
  const [avanzamento, setAvanzamento] = useState({});
  const [addableOrder, setAddableOrder] = useState(isAddable);
  const [editableOrder, setEditableOrder] = useState(isEditable);
  const [updatebleOrder, setUpdatebleOrder] = useState(isUpdateble);
  const { user } = useAuth(); 
  const [isCreating, setIsCreating] = useState(false);

  const numberFormatter = new Intl.NumberFormat('it-IT', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  useEffect(() => {

    const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoArticolo';
    var newUrl =  newServiceUrl + "/GetAction";

    const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/UnitaMisura';
    var newUrl2 =  newServiceUrl2 + "/GetAction";

    const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Articoli';
    var newUrl3 =  newServiceUrl3 + "/GetAction";

    const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Imposta';
    var newUrl4 =  newServiceUrl4 + "/GetAction";

    const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ArticoloCategoria';
    var newUrl5 =  newServiceUrl5 + "/GetAction";

    const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineFornitore';
    var newUrl6 =  newServiceUrl6 + "/GetProgress/" + props.data.key; 

    const fetchData = async () => {
      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };
        
        const response = await fetch(newUrl);
        const json = await response.json();
        console.log(json);
        setTipiArticolo(json);

        const response2 = await fetch(newUrl2);
        const json2 = await response2.json();
        console.log(json2);
        setUm(json2);

        const response3 = await fetch(newUrl3);
        const json3 = await response3.json();
        console.log(json3);
        setArticoli(json3);

        const response4 = await fetch(newUrl4);
        const json4 = await response4.json();
        console.log(json4);
        setImposte(json4);

        const response5 = await fetch(newUrl5);
        const json5 = await response5.json();
        console.log(json5);
        setCategorie(json5);

        const response6 = await fetch(newUrl6,requestOptions);
        const json6 = await response6.json();
        console.log(json6);
        setAvanzamento(json6);

      } catch (error) {
          console.log("error", error);
      }
    };
    fetchData();
  }, []);

  async function getArticle(id)  {

    if (id == null)
      id = 0;
    
      var serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Articolo/GetAction/' + id;

    const requestOptions = {
      method: 'GET',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        //Authorization: `Bearer ${this.state.loggedUser.token}`
      }
    };
  
    return fetch(serviceUrl, requestOptions)
    .then(response => {
      if(response.ok) return response.json();
      //Global.CheckResponseAuth(response);
      return null;
    })

    .then(data => { 
      return data;
    })
    .catch(error => { notify(error, 'error', 5000); }); 
  }

  async function setArticleValues(newData, value, currentRowData) {

    console.log("ARTICOLO: " + value);
    return getArticle(value).then(data => {
      newData.articoloId = value;
      newData.codice = data.codice;
      newData.codiceAlias = data.codiceFornitore;
      newData.paUnitario = data.prezzoAcquisto;
      newData.descrizione = data.descrizione;
      newData.impostaId = data.impostaId;
      newData.tipoRigaId = data.tipoArticoloId;
      newData.umid = data.umid;
      newData.paSconto = 0;
      newData.paScontato = 0;
      newData.paTotale = 0;
      newData.quantità= 1;
      newData.pvPercRicarico = data.percRicarico;
    });
  }


  function customizeText(data) {
    return `Righe: ${data.value}`;
  }

  function customizeData(data) {
    return `PA Totale: ${formatNumber(data.value, '###,##0.00')}`;
  }

  function onInitNewRow(e) {
    e.data.ordineId = props.data.key || 0;;
    setTimeout(() => setIsCreating(true), 10);
  };

  function onEditCanceled(e) {
    setIsCreating(false);
  };

  function onSaved(e) {
    setIsCreating(false);
  };

    
  const onEditorPreparing = (e) => {
    if (e.parentType === "dataRow" && e.dataField === "articoloId") {
      //e.editorOptions.disabled = typeof e.row.data.tipoRigaId !== "number";
      e.editorOptions.disabled = typeof e.row.data.categoriaId !== "number";
      //notify(error, 'Modificato', 5000);
      //notify(`Modificato`, { type: 'warning' });
    }
  }

    const getFilteredArticoli = useCallback(
        (options) => {
          return {
            key: "id",
            store: new CustomStore({
              load: function (loadOptions) {
                // fake call server to get the list of article
                return new Promise((resolve) => {
                  setTimeout(() => {
                    const res = loadOptions.filter
                      ? articoli.filter((c) => c.categoriaId === options.data.categoriaId)
                      : articoli;
                    resolve(res);
                  }, 500);                
                });
              },
              byKey: function (key) {
                return new Promise((resolve) => {
                  resolve(articoli.find((c) => c.id === key));
                });
              }
            }),
            filter: options.data ? ["categoriaId", "=", options.data.categoriaId] : null
          };
        },
        [articoli]
      );

      const remoteDataSource = createStore({

        key: 'id',
        loadUrl: serviceUrl + '/Find',
        
        onBeforeSend: (method, ajaxOptions) => {
          if (method == "load" ) {    
            console.log("CHIAVE: " + filterPayload.idSuper);       
            var payload = ajaxOptions.data;
            payload.values = JSON.stringify(filterPayload);
            ajaxOptions.data = payload;          
          }  
        ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
        ;
        },
        insertUrl: serviceUrl + '/InsertAction',
        updateUrl:serviceUrl + '/UpdateAction',
        deleteUrl: serviceUrl + '/DeleteAction'
        
    });

    function calculateImportoTotale(rowData) {
        return (rowData.importoUnitario - (rowData.importoUnitario / 100 * rowData.percSconto)) * rowData.quantità;
    };

    function setCategoriaValue(rowData, value) {
        rowData.articoloId = null;
        this.defaultSetCellValue(rowData, value); 
      };

    function onReorder(e) {
      e.promise = processReorder(e);
    }
  
    async function processReorder(e) {
      
      const visibleRows = e.component.getVisibleRows();
      const newOrderIndex = visibleRows[e.toIndex].data.orderIndex;
  
      await remoteDataSource.update(e.itemData.id, { orderIndex: newOrderIndex });
      await e.component.refresh();
    }

    function onRowInserting(e) {
        e.data.createBy = user.name;
        e.data.ordineId = props.data.data.id
    };

    function onRowUpdating(e) {
        e.newData.updateBy = user.name;
    };

    const onCellPrepared = (e) => {
   
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // month is zero-based
      let dd = today.getDate();
      
      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;
      
      const todayFormatted = yyyy + '-' + mm + '-' + dd + 'T00:00:00';

      if (e.rowType === "data") {
          if (e.column.dataField === "dataConsegna") 
          { 
            console.log("OGGI: " + todayFormatted);
            var dataConsegna = e.data.dataConsegna;
            var dataEvasione = e.data.dataEvasione;
            //console.log("CONSEGNA: " + dataConsegna);
            //console.log("EVASIONE: " + dataEvasione);
            if ((dataConsegna < todayFormatted) && dataEvasione === null)
            {
              //console.log("ROSSO: " );
              e.cellElement.style.cssText = "color: red";
            }
           
          }
      }
    }

    function GetAvanzamento() {

      var totaleEvaso = "";
      var totalePagato = "";
      var perc = 0;
      var percFormat = "";
      var perc2 = 0;
      var percFormat2 = "";
      if (avanzamento[0] !== undefined){
          totaleEvaso = numberFormatter.format(avanzamento[0].totaleEvaso);
          totalePagato = numberFormatter.format(avanzamento[0].totalePagamenti);
          if (avanzamento[0].totaleOrdine > 0) {
              perc = (((100 * avanzamento[0].totaleEvaso) / avanzamento[0].totaleOrdine)).toFixed(0);
              percFormat = "(" + perc + "%)"
              perc2 = (((100 * avanzamento[0].totalePagamenti) / avanzamento[0].totaleOrdine)).toFixed(0);
              percFormat2 = "(" + perc2 + "%)"
          }
      }
      
      return  (
          <div>
              <div className={'mystats-container-small'}>
                  <div div className={'mystats-data-small'}>Totale Evaso:&nbsp;<b>{totaleEvaso}</b>&nbsp;&nbsp;&nbsp;<b>{percFormat}</b></div>
                  <div div className={'mystats-data-small'}>Totale Pagato:&nbsp;<b>{totalePagato}</b>&nbsp;&nbsp;&nbsp;<b>{percFormat2}</b></div>
              </div>
          </div>
      )
    };
    
    return (
  
        <div>

          <div className="offer-title" align="left" > 
                <h2>Ordine n° {props.data.data.numeroDoc} del {props.data.data.strDataDoc} -  {props.data.data.fornitore}</h2>      
          </div>

          <GetAvanzamento></GetAvanzamento>

        <DataGrid id="grid-container"
          dataSource={remoteDataSource}
          showBorders={true}
          columnAutoWidth={true}
          onInitNewRow={onInitNewRow}
          onEditorPreparing={onEditorPreparing}
          onRowUpdating={onRowUpdating}
          onRowInserting={onRowInserting}
          onCellPrepared={onCellPrepared}
          dateSerializationFormat= {'yyyy-MM-dd'}
          //onToolbarPreparing = {onToolbarPreparing}
          onEditCanceled={onEditCanceled}
          onSaved={onSaved}
        >
          <Paging  defaultPageSize={40}/>
          <Pager showPageSizeSelector={true} showInfo={true} />

      
          
         
          <RowDragging
            allowReordering={editableOrder}
            onReorder={onReorder}
            dropFeedbackMode="push"
          />


            <Summary>
            <TotalItem
                column="codice"
                summaryType="count"
                customizeText={customizeText}
            />
            <TotalItem
              column="paTotale"
              summaryType="sum" 
              customizeText={customizeData}
              />
            </Summary>
            <Selection mode="single" />
            <Editing
              mode="row"
              allowUpdating={updatebleOrder}
              allowAdding={addableOrder}
              allowDeleting={editableOrder}
              useIcons={true}
            >
              
            </Editing>
            <Column dataField="id" visible={false}/>
            <Column dataField="ordineId" visible={false}/>
            
            <Column dataField="categoriaId" caption="Categoria"  width={240} setCellValue={setCategoriaValue} visible={editableOrder} allowEditing={addableOrder}>
                <Lookup dataSource={categorie} valueExpr="id" displayExpr="nome"/>
            </Column>
            <Column dataField="codiceAlias" caption="Codice" width={100} allowEditing={false}/>
    
            <Column dataField="articoloId" caption="Descrizione" width={480} setCellValue={setArticleValues} allowEditing={addableOrder}>
                <Lookup dataSource={getFilteredArticoli} valueExpr="id" displayExpr="descrizioneEstesa"/>
            </Column>
            <Column dataField="tipoRigaId" caption="Tipo"  width={60}  allowEditing={false}>
                <Lookup dataSource={tipiArticolo} valueExpr="id" displayExpr="codice"/>
            </Column>
            <Column dataField="impostaId" caption="IVA" width={60} allowEditing={editableOrder}>
                <Lookup dataSource={imposte} valueExpr="id" displayExpr="codice" />
            </Column> 
            <Column dataField="umid" caption="UM" width={60} allowEditing={editableOrder}>
                <Lookup dataSource={um} valueExpr="id" displayExpr="codice" />
            </Column>
            <Column dataField="quantità" caption="Q.tà" width={80} allowEditing={editableOrder}/>
            <Column dataField="importoUnitario" caption="Importo Unit." allowEditing={editableOrder}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="percSconto" caption="% Sconto" allowEditing={editableOrder}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="importoScontato"  caption="Importo Scontato" allowEditing={editableOrder}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="importoTotale" calculateCellValue={calculateImportoTotale} caption="Totale" allowEditing={false}>
                <Format type="fixedPoint" precision={2} />
            </Column> 

            <Column dataField="dataContratto" dataType={'date'} format= {'dd/MM/yyyy'} caption="Data Contratto" allowEditing={updatebleOrder}/>
            <Column dataField="dataConsegna" dataType={'date'} format= {'dd/MM/yyyy'} caption="Data Consegna" allowEditing={updatebleOrder}/>
            <Column dataField="dataEvasione" dataType={'date'} format= {'dd/MM/yyyy'} caption="Data Evasione" allowEditing={updatebleOrder}/>
            <Column dataField="updateBy" visible={false}/>
            <Column dataField="createBy" visible={false}/> 
        </DataGrid>

        </div>  
   
   )
};